/**
 * Common Switch Props
 */
export var switchProps = {
  size: [Number, String],
  value: null,
  loading: Boolean,
  disabled: Boolean,
  activeColor: String,
  inactiveColor: String,
  activeValue: {
    type: null,
    default: true
  },
  inactiveValue: {
    type: null,
    default: false
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/switch/shared.js
// module id = 226
// module chunks = 74